import { Box, Typography } from "@mui/material";
import React from "react";
import { colors } from "../../theme/theme";

const OverviewBox = ({ Icon, text, value }) => {
  return (
    <Box
      sx={{
        backgroundColor: "transparent",
        borderRadius: "14px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        border: "1px solid rgba(25,34,52,0.14)",
        py: 2,
      }}
    >
      <Icon sx={{ color: colors.secondary, fontSize: "24px", mb: 1 }} />
      <Typography
        sx={{
          color: colors.primary,
          fontFamily: "Mulish-ExtraBold",
          fontSize: "24px",
        }}
      >
        {value}
      </Typography>
      <Typography
        sx={{
          color: colors.primary,
          fontFamily: "Mulish-Regular",
          fontSize: "14px",
          textAlign: "center",
          px: 2,
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default OverviewBox;
